<template>
  <div class="app-wrapper" :class="classObj">
    <navbar></navbar>
    <div class="cont">
      <sidebar class="sidebar-container" ></sidebar>
      <app-main class="cont_cont"></app-main>
    </div>
    <!-- <sidebar class="sidebar-container" ></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div> -->
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: #F6F7F9;
    display: flex;
    flex-direction: column;
  }
  .app-wrapper .cont{
    display: flex;
    flex: 1;
    margin-top: 24px;
    overflow-y: auto;
  }
  .app-wrapper .cont .cont_cont{
    min-height: 96% !important;
    flex: 1;
    height: 97%;
    margin: 0 24px;
    background-color: #FFFFFF;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue